<template>
    <li class="product-item" @click="goProductDetail(productVal.id)">
        <div class="product-detail">
            <div class="product-left">
                <img :src="productVal.app_logo" alt="">
            </div>
            <div class="product-right">
                <p class="right-title">{{productVal.name}}</p>
                <div class="right-attention">
                    <el-rate
                        class="star-rate"
                        v-model="productVal.star"
                        :disabled="true"
                        void-icon-class="el-icon-star-on"
                        disabled-void-color="#c4c6cc"
                        :colors="['#fe9c00', '#fe9c00', '#fe9c00']">
                    </el-rate>
                    <div class="icon" @click.stop="handleCollect(productVal)">
                        <el-tooltip class="item" effect="dark" :content="productVal.is_collected ? '取消收藏' : '添加收藏'" placement="top">
                            <span :class="['icon-heart', {'icon-heart-shape': productVal.is_collected}]"></span>
                        </el-tooltip>
                        {{productVal.fan_num}}
                    </div>
                    <span class="icon" @click.stop="download(productVal.id)">
                        <el-tooltip class="item" effect="dark" content="下载应用" placement="top">
                            <span class="icon-download"></span>
                        </el-tooltip>
                        {{productVal.download_num}}
                    </span>
                </div>
            </div>
            <img v-if="productVal.pay_type === 3" class="inquiry" src="../../images/application_detail/inquiry.png">
        </div>
        <p class="product-desc" v-html="filterXSS(productVal.desc)"></p>
        <div class="product-footer" @click.stop>
            <img @click="goHomePage(productVal.user.id)" height="26" :src="productVal.user.avatar" alt="">
            <div class="current-version">
                <span class="title">当前版本 : </span>
                <span>{{productVal.on_line_version.current_version || '--'}}</span>
            </div>
            <div class="update-time">
                <span class="title">更新时间 : </span>
                <span>{{productVal.on_line_version.update_time || '--'}}</span>
            </div>
        </div>
    </li>
</template>

<script>
import bus from '@/js/bus.js'
export default {
    props: {
        productInfo: {
            type: Object,
            default: () => {}
        },
        isPersonCenter: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            productVal: {}
        }
    },
    watch: {
        productInfo: {
            handler(val) {
                this.productVal = JSON.parse(JSON.stringify(val))
            },
            immediate: true
        }
    },
    computed: {
        isLogin () {
            return this.$store.state.isLogin
        },
        userInfo () {
            return this.$store.state.userInfo
        }
    },
    methods: {
        // 前往作品详情
        goProductDetail (appId) {
            window.open(`/s-mart/application/${appId}/detail`, '_blank')
        },
        // 处理收藏事件
        handleCollect (row) {
            if (!this.isLogin) {
                //请求登录
                axios.post(myUrl + "login/get_user_info/")
                return
            }
            // 校验信息是否完善
            if (!this.$store.state.informationComplete) {
                bus.$emit('openInformationPopup', 'downLoad');
                return;
            }
            this.handleToggleCollect(row.id, row.is_collected)
        },
        // 收藏/取消收藏作品
        handleToggleCollect(appId, isCollected) {
            try {
                const url = isCollected ? 'sns/unfavorite/product/' : 'sns/collect/product/'
                axios.post(myUrl + url + appId + "/").then((res) => {
                    const resp = res.data
                    if (resp.result) {
                        const productVal = this.productVal
                        productVal.is_collected = !productVal.is_collected
                        const fans = productVal.fan_num
                        productVal.fan_num = isCollected ? fans - 1 : fans + 1
                        // 个人中心我关注的作品取消收藏时需在列表清除掉
                        if (this.isPersonCenter && isCollected) {
                            this.$emit('handleToggleCollect', appId)
                        }
                        this.$message({
                            message: resp.message,
                            type: 'success'
                        })
                    }
                })
            } catch (error) {
                console.warn(error)
            }
        },
        // 下载
        download(appId) {
            try {
                if (!this.isLogin) {
                    //请求登录
                    axios.post(myUrl + "login/get_user_info/")
                    return
                }
                // 校验信息是否完善
                if (!this.$store.state.informationComplete) {
                    bus.$emit('openInformationPopup', 'downLoad');
                    return;
                }
                const needFields = ['company', 'nick_name', 'qq', 'server_node'].map(field => this.userInfo[field]).every(field => field)
                if (!needFields) {
                    this.$emit('openInformationPopup')
                    return
                }
                // 获取下载链接
                axios.post(myUrl + "core/product/download/" + appId + "/").then((res) => {
                    const resp = res.data
                    if (resp.result) {
                        window.location.href = resp.data
                    }
                })
            } catch (error) {
                console.warn(error)
            }
            
        },
        // 跳转到个人主页
        goHomePage (userId) {
            // 判断是否为自己或者他人
            const isMatch = this.userInfo.user_id === userId
            const path = isMatch ? '/s-mart/personal_center/' : `/s-mart/personal_center/user/${userId}`
            let routeData = this.$router.resolve({
                path
            })
            window.open(routeData.href, '_blank')
        }   
    }
}
</script>

<style lang="scss" scoped>
    .product-item {
        width: 376px;
        height: 231px;
        background: #fff;
        border-radius: 2px;
        box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.10); 
        margin: 0 16px 17px 0;
        display: flex;
        flex-direction: column;
        font-size: 12px;
        cursor: pointer;
        .product-detail {
            position: relative;
            display: flex;
            align-items: center;
            padding: 22px 16px 18px;
            .product-left {
                width: 56px;
                height: 56px;
                background: #f0f1f5;
                border-radius: 8px;
                padding: 6px;
                margin-right: 16px;
                flex-shrink: 0;
                img {
                    height: 100%;
                    width: 100%;
                    border-radius: 6px;
                }
            }
            .product-right {
                flex: 1;
                .right-title {
                    font-weight: 700;
                    font-size: 16px;
                    color: #313238;
                    margin-bottom: 5px;
                }
                .right-attention {
                    display: flex;
                    align-items: center;
                    .star-rate {
                        height: auto;
                    }
                }
                .default-icon {
                    color: #c4c6cc;
                    font-size: 16px;
                }
                .checked {
                    color: #fe9c00;
                }
                .icon {
                    display: flex;
                    align-items: center;
                    margin-left: 38px;
                    font-size: 12px;
                    color: #4f515e;
                    position: relative;
                    .icon-download {
                        display: inline-block;
                        margin-right: 6px;
                        width: 15px;
                        height: 15px;
                        background: url('../../images/application_detail/download.png');
                        background-size: 100% 100%;
                        &:hover {
                            background: url('../../images/application_detail/hover-download.png');
                            background-size: 100% 100%;
                        }
                    }
                    .icon-heart {
                        width: 15px;
                        height: 15px;
                        margin-right: 6px;
                        background: url('../../images/application_detail/icon-heart2.png');
                        background-size: 100% 100%;
                        &:hover {
                            background: url('../../images/application_detail/icon-heart3.png');
                            background-size: 100% 100%;
                        }
                    }
                    .icon-heart-shape {
                        background: url('../../images/application_detail/icon-heart3.png');
                        background-size: 100% 100%;
                    }
                }
            }
            .inquiry {
                position: absolute;
                top: -2px;
                left: -3.5px;
                height: 51px;
                width: 54px;
            }
        }
        .product-desc {
            flex: 1;
            padding: 0 16px;
            color: #63656e;
            line-height: 23px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
        }
        .product-footer {
            height: 39px;
            border-top: 1px solid #f0f1f5;
            color: #979ba5;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 21px;
            cursor: default;
            img {
                cursor: pointer;
            }
            .current-version,
            .update-time {
                display: flex;
                align-items: center;
                .title {
                    flex-shrink: 0;
                    margin-right: 5px;
                }
            }
        }
        &:hover {
            box-shadow: 0px 4px 6px 0px rgba(0,0,0,0.10); 
        }
    }
</style>


// WEBPACK FOOTER //
// product.vue?39ff72a6